import { readCookie } from '@zapier/cookies';
import isProduction from './isProduction';

export const getCookie = (id: string) => {
  if (!isProduction()) {
    // Consider switching to `readCookie` from `@zapier/cookies`.
    // eslint-disable-next-line no-console
    console.warn('@zapier/common-utils `getCookie` is deprecated.');
  }
  try {
    return readCookie(id);
  } catch (e) {
    return undefined;
  }
};

export default getCookie;
